// extracted by mini-css-extract-plugin
export default {"issues":"global_issues__nk5GT"};